import React from "react";

interface ISocialFacebookIconProps {
    onClick(): void;
}

export const SocialFacebookIcon = ({onClick = () => {}}: ISocialFacebookIconProps) => (
    <i className="icon ion-social-facebook-outline" onClick={onClick} />
);
